import { InventoryComponent } from './pages/inventory.component';
import { SystemInventoryManagementComponent } from './inventory-management/system-inventory-management/system-inventory-management.component';
import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { RouterModule } from '@angular/router';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { InventoryService } from './inventory-service.service';
import { SharedModule } from '../../shared/shared.module';
import { MaterialModule } from '../../shared/material.module';
import { ActionPopupComponent } from '../action/action-popup/action-popup-inInventory/action-popup.component';
import { ActionModule } from '../action/action-module';
import { WsreCreateNewInspectionComponent } from './inventory-management/wsre-create-new-inspection/wsre-create-new-inspection.component';
import { UploadPhotoComponent } from '../interpretation/components/upload-photo/upload-photo.component';
import { InterpretationModule } from '../interpretation/interpretation.module';
import { CostEditPopupComponent } from './inventory-management/cost-edit-popup/cost-edit-popup.component';
import { InventoryRecordActionComponent } from './inventory-record-action/inventory-record-action.component';


@NgModule({
    imports: [
        CommonModule,
        RouterModule,
        SharedModule,
        MaterialModule,
        FormsModule,
        ReactiveFormsModule,
        ActionModule,
        InterpretationModule
    ],
    declarations: [
        InventoryComponent,
        SystemInventoryManagementComponent,
        WsreCreateNewInspectionComponent,
        CostEditPopupComponent,
        InventoryRecordActionComponent,
    ],
    providers: [
        InventoryService
    ]
})
  export class InventoryModule { }
